// TelefonInput — JEDINÉ pole na telefónne číslo v celom Matrixe (Mirko GO 2026-07-29).
//
// „Chcel som, aby pole telefón v Matrixe NEUMOŽNILO iné zadávanie ako medzinárodné."
//
// Preto zámok na VSTUPE, nie oprava zozadu: čo sa dá zapísať, je rovno správne. Užívateľ smie
// napísať 0918…, systém to sám prepíše na +421 918 … a povie mu to. Čo sa prepísať nedá,
// pole ODMIETNE a vysvetlí prečo — neuloží sa nezmysel, ktorý potom nikto nevie poslať.
//
// PRAVIDLO: nikde v Matrixe sa telefón nezadáva cez holý <input>. Vždy cez tento komponent.
import React, { useState, useEffect } from 'react'
import { COLORS, TYPO, RADIUS } from '../theme.js'

// Krajiny, ktoré reálne voláme. Poradie = pravdepodobnosť.
const KRAJINY = [
  { pref: '+421', dlzka: 9, nazov: 'Slovensko' },
  { pref: '+420', dlzka: 9, nazov: 'Česko' },
  { pref: '+48',  dlzka: 9, nazov: 'Poľsko' },
  { pref: '+43',  dlzka: 9, nazov: 'Rakúsko' },
  { pref: '+36',  dlzka: 9, nazov: 'Maďarsko' },
  { pref: '+380', dlzka: 9, nazov: 'Ukrajina' },
  { pref: '+49',  dlzka: 10, nazov: 'Nemecko' },
]

// Vráti { ok, hodnota, sprava }. Nikdy nehádže.
export function normalizujTelefon(raw) {
  const s = String(raw == null ? '' : raw).trim()
  if (!s) return { ok: true, hodnota: '', sprava: '' }

  let v = s.replace(/[^\d+]/g, '')
  if (v.startsWith('00')) v = '+' + v.slice(2)

  // domáce číslo bez predvoľby → doplň slovenskú
  if (!v.startsWith('+')) {
    if (/^0\d{9}$/.test(v)) v = '+421' + v.slice(1)
    else if (/^(421|420|380)\d{9}$/.test(v)) v = '+' + v
    else if (/^(48|43|36)\d{9}$/.test(v)) v = '+' + v
    else if (/^49\d{10}$/.test(v)) v = '+' + v
    else {
      return { ok: false, hodnota: s,
        sprava: 'Telefón musí byť v medzinárodnom tvare — napr. +421 918 123 456. Domáce číslo napíš ako 0918123456 a doplní sa samo.' }
    }
  }

  const cif = v.replace(/\D/g, '')
  const k = KRAJINY.find(x => cif.startsWith(x.pref.slice(1)))
  if (!k) {
    return { ok: false, hodnota: v,
      sprava: 'Neznáma medzinárodná predvoľba. Používame: ' + KRAJINY.map(x => x.pref).join(', ') + '.' }
  }
  const zvysok = cif.slice(k.pref.length - 1)
  if (zvysok.length !== k.dlzka) {
    return { ok: false, hodnota: v,
      sprava: `${k.nazov} (${k.pref}) má ${k.dlzka} číslic za predvoľbou — zadal si ${zvysok.length}.` }
  }
  // pekný tvar: predvoľba + trojice (nemecké 10 číslic → 3-3-4)
  const skupiny = k.dlzka === 9
    ? [zvysok.slice(0, 3), zvysok.slice(3, 6), zvysok.slice(6)]
    : [zvysok.slice(0, 3), zvysok.slice(3, 6), zvysok.slice(6)]
  return { ok: true, hodnota: k.pref + ' ' + skupiny.filter(Boolean).join(' '), sprava: '' }
}

export default function TelefonInput({ value, onChange, placeholder, disabled, style, title, autoFocus }) {
  const [txt, setTxt] = useState(String(value || ''))
  const [chyba, setChyba] = useState('')
  const [info, setInfo] = useState('')

  useEffect(() => { setTxt(String(value || '')); setChyba(''); setInfo('') }, [value])

  const dokonci = () => {
    const r = normalizujTelefon(txt)
    if (!r.ok) { setChyba(r.sprava); setInfo(''); return }
    setChyba('')
    setInfo(r.hodnota && r.hodnota !== String(value || '') ? 'Upravené na medzinárodný tvar' : '')
    setTxt(r.hodnota)
    if (r.hodnota !== String(value || '')) onChange && onChange(r.hodnota)
  }

  return (
    <div>
      <input
        type="tel"
        value={txt}
        disabled={disabled}
        autoFocus={autoFocus}
        title={title || 'Medzinárodný tvar, napr. +421 918 123 456. Domáce číslo (0918…) sa doplní samo.'}
        placeholder={placeholder || '+421 918 123 456'}
        onChange={e => { setTxt(e.target.value); if (chyba) setChyba(''); if (info) setInfo('') }}
        onBlur={dokonci}
        onKeyDown={e => { if (e.key === 'Enter') dokonci() }}
        style={{ ...(style || {}), ...(chyba ? { borderColor: COLORS.remove, background: 'rgba(239,68,68,0.04)' } : {}) }}
      />
      {chyba
        ? <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.remove, marginTop: 2, lineHeight: 1.3 }}>{chyba}</div>
        : (info ? <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.add, marginTop: 2 }}>{info}</div> : null)}
    </div>
  )
}
